import React, { useEffect, useState } from 'react';

function Hollydays() {
  const [pendingHollydays, setPendingHollydays] = useState([]);
  const [hollydaysHistory, setHollydaysHistory] = useState([]);
  const [representatives, setRepresentativesList] = useState([]);
  const [selectedRep, setSelectedRep] = useState("");
  const [repTotalHollydays, setRepTotalHollydays] = useState("");

  useEffect(() => {
    getPendingHollydays();
    getHollydaysHistory(); // Fetch all holidays by default
    getRepresentativesList();
  }, []);

  async function getPendingHollydays() {
    try {
      const response = await fetch(
        "https://cairomed-backend.vercel.app/api/holiday-requests/pending"
      );
      if (!response.ok) {
        throw new Error("Failed to fetch pending holidays data");
      }
      const filteredData = await response.json();
      setPendingHollydays(filteredData.data.holidayRequests || []);
    } catch (error) {
      console.error("Error fetching pending holidays:", error);
    }
  }

  async function updateHolidayStatus(hollydayID, status) {
    try {
      const bodyData = {
        status: status,
        reason: status === "accepted" ? "Approved by admin" : "Rejected by admin"
      };

      const response = await fetch(
        `https://cairomed-backend.vercel.app/api/holiday-requests/status/${hollydayID}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(bodyData),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to update holiday status");
      }

      setPendingHollydays((prevHolidays) =>
        prevHolidays.filter((holiday) => holiday._id !== hollydayID)
      );
    } catch (error) {
      console.error("Error updating holiday:", error);
    }
  }

  async function getRepresentativesList() {
    try {
      const response = await fetch(
        "https://cairomed-backend.vercel.app/api/representatives/getRepresentatives"
      );
      if (!response.ok) {
        throw new Error("Failed to fetch representatives data");
      }
      const data = await response.json();
      setRepresentativesList(data);
      console.log(data);
    } catch (error) {
      console.error("Error fetching representatives:", error);
    }
  }

  async function getHollydaysHistory() {
    try {
      const response = await fetch(
        "https://cairomed-backend.vercel.app/api/holiday-requests"
      );
      if (!response.ok) {
        throw new Error("Failed to fetch holidays history data");
      }
      const filteredData = await response.json();
      setHollydaysHistory(filteredData.data.holidayRequests || []);
    } catch (error) {
      console.error("Error fetching holidays history:", error);
    }
  }

  async function fetchRepHolidays(repId) {
    try {
      if (!repId) {
        getHollydaysHistory(); // Show all holidays if rep is cleared
        return;
      }

      const response = await fetch(
        "https://cairomed-backend.vercel.app/api/holiday-requests/summary",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ representativeId: repId }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch holiday summary");
      }

      const data = await response.json();
      setHollydaysHistory(data.data.acceptedHolidayRequests || []);
      setRepTotalHollydays(data.data.total_days_taken);
      console.log(data)
    } catch (error) {
      console.error("Error fetching holiday summary:", error);
    }
  }

  const handleRepChange = (event) => {
    const selectedId = event.target.value;
    setSelectedRep(selectedId);
    fetchRepHolidays(selectedId); // Fetch holidays for the selected rep
  };

  return (
    <>
      {/* Pending Holidays Table */}
      <div className="table-wrapper">
        <table className="table">
          <thead>
            <tr>
              <th>Rep Name (EN)</th>
              <th>Date</th>
              <th>Reason</th>
              <th>Status</th>
              <th>Accept</th>
              <th>Reject</th>
            </tr>
          </thead>
          <tbody>
            {pendingHollydays.length > 0 ? (
              pendingHollydays.map((hollyday) => (
                <tr key={hollyday._id}>
                  <td>{hollyday.representativeName}</td>
                  <td>{hollyday.startDate}</td>
                  <td>{hollyday.reason}</td>
                  <td>{hollyday.status}</td>
                  <td>
                    <button className='btn btn-success' onClick={() => updateHolidayStatus(hollyday._id, "accepted")}>
                      Accept
                    </button>
                  </td>
                  <td>
                    <button className='btn btn-danger' onClick={() => updateHolidayStatus(hollyday._id, "rejected")}>
                      Reject
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">No holidays found...</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Holiday History Table with Select Input */}
      <div>
        <select
          value={selectedRep}
          onChange={handleRepChange}
          className='select-representative-hollydays'
        >
          <option value="">All Representatives</option>
          {representatives.map((rep) => (
            <option key={rep._id} value={rep._id}>
              {rep.NameEN}
            </option>
          ))}
        </select>
        <div className='holydays-total-box'>
          <h4>Total:</h4>       
<h3>24/{repTotalHollydays}</h3>  
          <span>days</span>
        </div>
      </div>
      <div className="table-wrapper">
        {/* Rep Selection Dropdown */}

        <table className="table">
          <thead>
            <tr>
              <th>Rep Name (EN)</th>
              <th>Date</th>
              <th>Reason</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {hollydaysHistory.length > 0 ? (
              hollydaysHistory.map((hollyday) => (
                <tr key={hollyday._id}>
                  <td>{hollyday.representativeName}</td>
                  <td>{hollyday.startDate}</td>
                  <td>{hollyday.reason}</td>
                  <td>{hollyday.status}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4">No holidays found...</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default Hollydays;
